// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kEHM","top":"styles_top__12ouI"};